import { Shield, Users, Lock, Eye } from 'lucide-react'

export default function RolesPermissionsSettings() {
  const roles = [
    {
      id: 'super_admin',
      name: 'Super Administrateur',
      description: 'Accès complet à toutes les fonctionnalités',
      permissions: ['Tous les droits', 'Gestion des utilisateurs', 'Configuration système'],
      color: 'red',
      count: 1
    },
    {
      id: 'responsable',
      name: 'Responsable',
      description: 'Gestion de l\'équipe et administration',
      permissions: ['Gestion équipe', 'Projets', 'Rapports'],
      color: 'orange',
      count: 3
    },
    {
      id: 'enseignant',
      name: 'Enseignant',
      description: 'Gestion des projets et évaluations',
      permissions: ['Créer projets', 'Évaluer', 'Consulter rapports'],
      color: 'blue',
      count: 12
    },
    {
      id: 'collaborateur',
      name: 'Utilisateur',
      description: 'Accès de base aux fonctionnalités',
      permissions: ['Consulter projets', 'Participer'],
      color: 'gray',
      count: 24
    }
  ]

  return (
    <div className="space-y-6">
      <div className="card">
        <div className="card-header">
          <div>
            <h3 className="card-title">Rôles et permissions</h3>
            <p className="card-subtitle">Gérez les rôles et leurs permissions</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {roles.map((role) => (
          <div key={role.id} className="card">
            <div className="p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex gap-3">
                  <div className={`w-12 h-12 bg-${role.color}-100 rounded-lg flex items-center justify-center`}>
                    <Shield className={`h-6 w-6 text-${role.color}-600`} />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">{role.name}</h4>
                    <p className="text-sm text-muted">{role.description}</p>
                  </div>
                </div>
                <span className={`badge badge-${role.color === 'gray' ? 'neutral' : role.color === 'red' ? 'danger' : role.color === 'orange' ? 'warning' : 'primary'}`}>
                  {role.count} {role.count > 1 ? 'utilisateurs' : 'utilisateur'}
                </span>
              </div>

              <div className="mt-4">
                <h5 className="text-sm font-medium text-gray-700 mb-2">Permissions:</h5>
                <ul className="space-y-1">
                  {role.permissions.map((permission, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-muted">
                      <Eye className="h-4 w-4 text-green-600" />
                      {permission}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
